// ref: https://www.twilio.com/docs/whatsapp/guidance-whatsapp-media-messages
export const WHATSAPP_ATTACHMENT_ACCEPTED_MIME =
  "image/jpeg,image/png,application/pdf";
export const WHATSAPP_ATTACHMENT_IMAGE_SIZE_LIMIT_MB = 5;
export const WHATSAPP_ATTACHMENT_DOCUMENT_SIZE_LIMIT_MB = 16;
